import { PROGRESS_START, PROGRESS_FAIL, PROGRESS_FINISH } from "../../mutation-types";
import commonApi from "../../../api/common";

const defaultState = () => ({
    mitraMLM: {
        status: false
    },
    mitraID: {},
    Mandatory: {},
    konfirmResponse: {},
    province_area: [],
    dataProvince: [],
    dataCity: [],
    mandatoryError: {
        ktp: '',
        hp: ''
    },
    province: [],
    city: [],
    subdistrict: [],
    paramsAddress: {
        province: '',
        city: '',
        subdistrict: '',
        address: '',
        lat: '',
        lng: '',
    }
});

const state = defaultState();

const getters = {};

const mutations = {
    datamitraMLM(state, data) {
        state.mitraMLM = Object.assign({}, state.mitraMLM, data);
    },
    resetmitraMLM(state) {
        state.mitraMLM = {
            status: false
        };
    },
    listmitraID(state, data) {
        state.mitraID = Object.assign({}, state.mitraID, data);
    },
    listdataProvince(state, data) {
        state.dataProvince = [...data];
    },
    listdataCity(state, data) {
        state.dataCity = [...data];
    },
    listMandatory(state, data) {
        state.Mandatory = Object.assign({}, state.Mandatory, data);
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = data;
    },
    setAlertMandatory(state, data) {
        state.mandatoryError[data.type] = data.data
    },
    setProvince(state, data) {
        state.province = data
    },
    setCity(state, data) {
        state.city = data
    },
    setSubdistrict(state, data) {
        state.subdistrict = data
    },
    setAddressDefault(state, data) {
        state.paramsAddress.province = {
            id: data.stockist_origin_province_id,
            text: data.stockist_origin_province_name,
        }
        state.paramsAddress.city = {
            id: data.stockist_origin_city_id,
            text: data.stockist_origin_city_name,
        }
        state.paramsAddress.subdistrict = {
            id: data.stockist_origin_subdistrict_id,
            text: data.stockist_origin_subdistrict_name,
        }
        state.paramsAddress.address = data.stockist_origin_address
        state.paramsAddress.lat = parseFloat(data.stockist_latitude)
        state.paramsAddress.lng = parseFloat(data.stockist_longitude)
    }
};
const actions = {
    async getmitraMLM({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        await commonApi.cekMitraMLM(param).then(({ data: { data } }) => {
            commit("datamitraMLM", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            commit("resetmitraMLM");
            const data = err.response.data.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getmitraID({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        commonApi.cekMitraMLM(param).then(({ data: { data } }) => {
            commit("listmitraID", data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getDataArea({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        commonApi.dataAreaMLM(param).then(({ data: { data: { results } } }) => {
            if (param.type == "province") {
                commit("listdataProvince", results);
            } if (param.type == "city") {
                commit("listdataCity", results);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    async checkMandatory({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        await commonApi.mandatoryCheck(param).then(() => {
            commit("setAlertMandatory", {type: param.type, data: ''})
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data.message;
            const type = err.config.params.type
            commit("setAlertMandatory", {type: type, data: data})
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getProvince({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        commonApi.getProvince(param).then(({ data: { data: { results } } }) => {
            commit('setProvince', results)
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            commit('setProvince', [])
            const data = err.response.data.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getCity({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        commonApi.getCity(param).then(({ data: { data: { results } } }) => {
            commit('setCity', results)
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            commit('setCity', [])
            const data = err.response.data.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getSubdistrict({ commit }, param) {
        commit(PROGRESS_START, null, { root: true });
        commonApi.getSubdistrict(param).then(({ data: { data: { results } } }) => {
            commit('setSubdistrict', results)
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            commit('setSubdistrict', [])
            const data = err.response.data.data;
            commit("saveConfirmResponse", data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};